import type { LiveCommerceReminder } from "@repo/api-client";
import { liveCommerceService } from "@repo/api-client";
import type { Reminder } from "../types/upcoming-live.types";

export interface ReminderServiceAdapter {
  getUserReminders: (payload: { mobileNo: string; influencerId?: string }) => Promise<{
    data?: { reminders: Reminder[] };
    message?: string;
  }>;
  setReminder: (payload: {
    mobileNo: string;
    influencerId: string;
    videoId: string;
  }) => Promise<{ data?: { reminder: Reminder }; message?: string }>;
  removeReminder: (payload: {
    mobileNo: string;
    videoId: string;
    influencerId: string;
  }) => Promise<{
    data?: { deleted: boolean };
    message?: string;
  }>;
}

function mapToReminder(r: LiveCommerceReminder, mobileNo: string): Reminder {
  return {
    id: r.id,
    videoId: r.videoId,
    influencerId: r.influencerId,
    isActive: r.isActive,
    createdAt: r.createdAt,
    updatedAt: r.updatedAt,
    mobileNo,
  };
}

export function createReminderService(): ReminderServiceAdapter {
  return {
    async getUserReminders({ mobileNo, influencerId }) {
      const res = await liveCommerceService.getUserReminders({ mobileNo, influencerId });
      const reminders = (res.data?.reminders ?? []).map((r) => mapToReminder(r, mobileNo));
      return { data: { reminders }, message: res.message };
    },
    async setReminder(payload) {
      const res = await liveCommerceService.setReminder(payload);
      const reminder = res.data?.reminder
        ? mapToReminder(res.data.reminder, payload.mobileNo)
        : undefined;
      return { data: reminder ? { reminder } : undefined, message: res.message };
    },
    async removeReminder(payload) {
      const res = await liveCommerceService.removeReminder(payload);
      return {
        data: { deleted: res.data?.deleted ?? false },
        message: res.message,
      };
    },
  };
}

export const defaultReminderService = createReminderService();
